<template>
  <v-footer bg-color="background">
    <v-container class="pa-0 ma-0" bg-color="background" fluid>
      <v-row bg-color="background">
        <v-col xxl="9" xl="9" lg="9" md="8" sm="12" xs="12" class="align-right pt-8">
          <span class="app-version">v{{ appVersionStr }}</span>
        </v-col>
        <v-col xxl="3" xl="3" lg="3" md="4" sm="12" xs="12" class="cr pt-9 pr-8">
          <router-link to="/oneshot" title="OneShot App" class="footer-nav-link">OneShot</router-link>
          <span class="mx-2">|</span>
          <router-link to="/privacy" title="User Terms & Conditions" class="footer-nav-link">Terms</router-link>
          <span class="mx-2">|</span>
          <router-link to="/privacy" title="Privacy Policy" class="footer-nav-link">Privacy Policy</router-link>
          <span class="mx-2">|</span>
          <a href="https://docs.missionsquad.ai" target="_blank" rel="noopener" title="Documentation"
            class="footer-nav-link">Docs</a>
          <span class="mx-2">|</span>
          © Mission Squad 2026
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>
<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import { submitEmail } from '@/utils/api'
import { checkEmail } from '@/utils/general'
import { mapGetters } from 'vuex'

@Options({
  computed: {
    ...mapGetters(['appVersion']),
    breakpoint() {
      return this.$vuetify.display.name
    }
  },
  watch: {
    breakpoint(value: any) {
      // this.hide()
    }
  }
})
export default class FooterComponent extends Vue {
  public appVersion!: string
  public breakpoint!: string
  public emailAddress = ''
  public submitDisabled = true

  get appVersionStr() {
    return this.appVersion ?? '0.0'
  }

  public emailRules = [
    (v: string) => !!v || 'E-mail is required',
    (v: string) => checkEmail(v) || 'E-mail is invalid.',
  ]

  public verify() {
    // console.log(this.emailAddress)
    if (checkEmail(this.emailAddress)) {
      this.submitDisabled = false
    } else {
      this.submitDisabled = true
    }
  }

  public async sendEmail() {
    if (checkEmail(this.emailAddress)) {
      const success = await submitEmail(this.emailAddress)
      if (success) {
        this.emailAddress = ''
        //@ts-ignore
        this.$refs.emailInput.reset()
      }
    }
  }

  shouldHide(cols: string[]) {
    const bp = this.breakpoint ?? ''
    if (cols.includes(bp)) {
      return false
    }
    return true
  }
  
  shouldShow(cols: string[]) {
    const bp = this.breakpoint ?? ''
    if (cols.includes(bp)) {
      return true
    }
    return false
  }
}
</script>
<style lang="scss">
.cr {
  font-size: 12px;
  text-align: right;
}
.footer-nav-link {
  color: inherit; // Inherit color from parent
  text-decoration: none;

  &:hover {
    text-decoration: underline; // Optional: underline on hover
  }
}
.align-right {
  text-align: right;
}
.app-version {
  color: rgb(var(--v-theme-secondary-darken-2));
  font-size: 12px;
  font-weight: 500;
  position: absolute;
  left: 24px;
  bottom: 8px;
}
.v-footer {
  background-color: rgb(var(--v-theme-background)) !important;
}
</style>
